import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

const useDetectScrolledToBottom = (): boolean => {
  const [isBottom, setIsBottom] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isAtBottom = scrollTop + windowHeight >= documentHeight;

      setIsBottom(isAtBottom);
    }, 300);

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isBottom;
};

export default useDetectScrolledToBottom;
